let root;

let requests = {}

export default {
  install(Vue, options) {
    Vue.prototype.$requestManager = {
      setVue(_vue) {
        root = _vue
      },
      newRequest(tag) {
        if (requests[tag]) {
          try {
            requests[tag].cancel()
          } catch (e){
            console.log(e)
          }
        }

        let newRequestToken = root.axios.CancelToken.source()

        newRequestToken.token.promise.then(response => {
          requests[tag] = false
        })

        requests[tag] = newRequestToken

        return newRequestToken.token
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/RequestManager.js